export const styles = [
  "All",
  {title: "Stroke", type: "Rounded", id: "stroke-rounded"},
  {title: "Stroke", type: "Standard", id: "stroke-standard"},
  {title: "Duotone", type: "Rounded", id: "duotone-rounded"},
  {title: "Twotone", type: "Rounded", id: "twotone-rounded"},
  {title: "Solid", type: "Rounded", id: "solid-rounded"},
  {title: "Solid", type: "Standard", id: "solid-standard"},
  {title: "Bulk", type: "Rounded", id: "bulk-rounded"},
  {title: "Stroke", type: "Sharp", id: "stroke-sharp"},
  {title: "Solid", type: "Sharp", id: "solid-sharp"},
];

export const IconUrl = (icon) => {
  return `https://cdn.hugeicons.com/icons/${icon}.svg`;
};

export const CloudUrl = (name) => {
  return `https://cdn.hugeicons.com/${name}`;
};